import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Progress } from '@/components/ui/progress'

interface FinancialSummaryProps {
  totalPromised: string
  totalReceived: string
  realizationRate: number
  engagementGap?: string
}

export function FinancialSummary({
  totalPromised,
  totalReceived,
  realizationRate,
  engagementGap,
}: FinancialSummaryProps) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Resume financier</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
          <div>
            <p className="text-sm text-muted-foreground">Total promis</p>
            <p className="text-lg font-semibold tabular-nums">{totalPromised}</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Total encaisse</p>
            <p className="text-lg font-semibold tabular-nums">{totalReceived}</p>
          </div>
          {engagementGap && (
            <div>
              <p className="text-sm text-muted-foreground">Ecart</p>
              <p className="text-lg font-semibold tabular-nums">{engagementGap}</p>
            </div>
          )}
        </div>
        <div className="space-y-1.5">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Taux de realisation</span>
            <span className="font-medium tabular-nums">{realizationRate.toFixed(1)}%</span>
          </div>
          <Progress value={Math.min(realizationRate, 100)} className="h-2" />
        </div>
      </CardContent>
    </Card>
  )
}
